import gql from "graphql-tag";

export const getWalkLinesQuery = gql(`
    query GetWalkLines($areaId: String!) {
        getWalkLines(areaId: $areaId) {
            areaId
            lines {
                id
                points {
                    spotKey
                    lat
                    lng
                }
            }
            modifiedAt
        }
    }
`);

export const saveWalkLinesMutation = gql(`
    mutation SaveWalkLines($areaId: String!, $lines: [WalkLineIn!]!) {
        saveWalkLines(areaId: $areaId, lines: $lines) {
            areaId
            lines {
                id
                points {
                    spotKey
                    lat
                    lng
                }
            }
            modifiedAt
        }
    }
`);
